const providePhoneNumberExample = function (code) {
   let exampleNumber = "";
   switch (code) {
      case "44":
         exampleNumber = "01632960000"; // See Using example telephone numbers - https://design-system.service.gov.uk/patterns/telephone-numbers/
         break;
      case "1":
         exampleNumber = "4155552671"; // https://support.twilio.com/hc/en-us/articles/223183008-Formatting-International-Phone-Numbers
         break;
      default:
      // none
   }

   return exampleNumber;
};

export { providePhoneNumberExample };
